import type { FillLayer } from "react-map-gl";

export const permitSubmittedLayer: FillLayer = {
  id: "permitSubmitted",
  source: "St_Kilda_Road",
  // "source-layer": "St_Kilda_Road_V4",
  filter: ["in", "ApplicationStage", "INITASSESS", "PAYMENTRECEIVED","PUBNOTIFY","INFREQUEST", "ATPRPTNG", "S5057ALODG", "REFERRED", "UNDERASSES", "CON1PLAN", "COND1RECVD", "COORDREVIEW", "ADVTPREP"],
  // @ts-expect-error: "fill-extrusion" is being used intentionally here despite the type mismatch.
  type: "fill-extrusion",
  minzoom: 0,
  maxzoom: 24,
  paint: {
    // @ts-expect-error: "fill-extrusion-color" is being used intentionally here despite the type mismatch.
    "fill-extrusion-color": "#c85e19",
    "fill-extrusion-height": ["*", ["get", "BuildingHeight"], 1],
    "fill-extrusion-base": 0,
    "fill-extrusion-opacity": 1,
  },
};

export const baseLayer: FillLayer = {
  id: "baseLayer",
  source: "St_Kilda_Road",
  // "source-layer": "St_Kilda_Road_V4",
  filter: ["!in", "ApplicationStage", "APPROVED","PMTISSUED","ISSUED", "INITASSESS", "PAYMENTRECEIVED","PUBNOTIFY","INFREQUEST", "ATPRPTNG", "S5057ALODG", "REFERRED", "UNDERASSES", "CON1PLAN", "COND1RECVD", "COORDREVIEW", "ADVTPREP"],
  // @ts-expect-error: "fill-extrusion" is being used intentionally here despite the type mismatch.
  type: "fill-extrusion",
  minzoom: 0,
  maxzoom: 24,
  paint: {
    // @ts-expect-error: "fill-extrusion-color" is being used intentionally here despite the type mismatch.
    "fill-extrusion-color": "#eeeeee",
    "fill-extrusion-height": ["*", ["get", "EAVE_Elev"], 1],
    "fill-extrusion-base": 0,
    "fill-extrusion-opacity": 1,
  },
};

export const permitApprovedLayer: FillLayer = {
  id: "permitApproved",
  source: "St_Kilda_Road",
  // "source-layer": "St_Kilda_Road_V4",
  filter: ["in", "ApplicationStage", "APPROVED","PMTISSUED","ISSUED"],
  // @ts-expect-error: "fill-extrusion" is being used intentionally here despite the type mismatch.
  type: "fill-extrusion",
  minzoom: 0,
  maxzoom: 20,
  paint: {
    // @ts-expect-error: "fill-extrusion-color" is being used intentionally here despite the type mismatch.
    "fill-extrusion-color": "#1a9798",
    "fill-extrusion-height": ["*", ["get", "BuildingHeight"], 1],
    "fill-extrusion-base": 0,
    "fill-extrusion-opacity": 1,
  },
};

export const layers : Array<FillLayer> = [
    permitSubmittedLayer,
    permitApprovedLayer,
    baseLayer
]